import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { cn } from "helpers/classNames";

type Props = {
  className?: string;
};

export const NotesIcon = ({ className }: Props) => (
  <PencilSquareIcon className={cn("h-4 w-4 text-gray-400", className)} />
);
